import { useEffect } from "react";

const useConfirmNavigation = (message) => {
  useEffect(() => {
    const handleLinkClick = (e) => {
      const anchor = e.target.closest("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href");

      // ignore invalid or same-page links
      if (!href || href === "#" || href.startsWith("#")) return;
      if (href === window.location.pathname) return;

      e.preventDefault();
      e.stopPropagation();

      const confirmLeave = window.confirm(
        message ||
          "You are leaving the page.\nUnsaved changes will be lost.\n\nClick OK to leave.\nClick Cancel to stay and save."
      );

      if (confirmLeave) {
        window.location.href = href;
      }
    };

    document.addEventListener("click", handleLinkClick, true);

    return () => {
      document.removeEventListener("click", handleLinkClick, true);
    };
  }, [message]);
};

export default useConfirmNavigation;